import { roomData } from './data';
import { initRoomHandlers } from './init';
import { roomService } from './roomService';
import { getRoomById } from './utils';

// 导出类型
export * from './types';

// 导出 service 对象
export { roomService };

// 初始化函数
function init() {
    initRoomHandlers();
}

// 获取房间信息
function getRoomInfo(roomId: string) {
    return roomService.findRoomInfo(roomId);
}


// 导出 matrixRoom 对象以保持向后兼容
export const matrixRoom = {
    init,
    roomData,
    getRoomInfo,
    getRoomById
};

